'use strict';

/**
 * <loyalty-points>
 * Logic-only Web Component for loyalty UI in the minicart.
 * HTML is rendered server-side via snippets/loyalty-points.liquid.
 */
class LoyaltyPoints extends HTMLElement {
  constructor() {
    super();
    this._boundSignInHandler = null;
  }

  connectedCallback() {
    this.bindSignInModal();

    if (this.hasAttribute('data-customer')) {
      this.fetchAndDisplayBalance();
    }
  }

  disconnectedCallback() {
    this.unbindSignInModal();
  }

  /* ── Sign-in Modal Trigger ───────────────────────── */

  bindSignInModal() {
    this._boundSignInHandler = this.handleSignInClick.bind(this);
    this.addEventListener('click', this._boundSignInHandler);
  }

  unbindSignInModal() {
    if (this._boundSignInHandler) {
      this.removeEventListener('click', this._boundSignInHandler);
      this._boundSignInHandler = null;
    }
  }

  handleSignInClick(evt) {
    const btn = evt.target.closest('[data-reward-signin], .minicart-login-btn');
    if (!btn) return;

    const modalSignin = document.getElementById('log-in-form') || document.getElementById('rModal');
    if (modalSignin) {
      if (typeof $ !== 'undefined' && $.fn && $.fn.modal) {
        $(modalSignin).modal('show');
      } else {
        modalSignin.classList.add('show');
        modalSignin.style.display = 'block';
      }
    }
  }

  /* ── Loyalty Balance ────────────────────────────── */

  fetchAndDisplayBalance() {
    _theme.Loyalty?.fetchRewardBalance?.()?.then(res => {
      const balance = res?.data?.points_balance;
      if (balance === undefined) return;

      this.updateBalanceElements(balance);
      this.updateAmountElements(balance, res?.data?.points_balance_currency);
    }).catch(() => {});
  }

  updateBalanceElements(balance) {
    document.querySelectorAll('[data-reward-balance]').forEach(el => {
      el.textContent = balance;
    });
  }

  updateAmountElements(balance, currencyAmount) {
    let amount = currencyAmount;
    if (!amount) {
      amount = '$' + Math.floor(Number(balance) / 100);
    }
    amount = String(amount);
    if (!amount.startsWith('$')) {
      amount = '$' + amount;
    }
    document.querySelectorAll('[data-reward-amount]').forEach(el => {
      el.textContent = amount;
    });
  }
}

customElements.define('loyalty-points', LoyaltyPoints);
